export default "/images/vendor/flag-icon-css/flags/4x3/cf.svg?a3843e7991ac45d28efffd46408141d2";